export default __webpack_public_path__ + "static/media/avatar.f0d7bc03.png";